import type { Dialect, Driver, DatabaseIntrospector, Kysely, QueryCompiler } from 'kysely'
import { SqliteAdapter, SqliteIntrospector, SqliteQueryCompiler } from 'kysely'
import { WasmSqliteDriver } from '@/lib/custom-dialect'

export class SqlJsDialect implements Dialect {
  createAdapter() {
    return new SqliteAdapter()
  }

  createDriver(): Driver {
    return new WasmSqliteDriver()
  }

  createQueryCompiler(): QueryCompiler {
    return new SqliteQueryCompiler()
  }

  createIntrospector(db: Kysely<any>): DatabaseIntrospector {
    return new SqliteIntrospector(db)
  }
}
